export const benefitsList = [
  {
    id: "benefit-1",
    title: "Daily Updated",
    description: "Our kakobuy spreadsheet is refreshed every day with the latest product listings, ensuring you never miss out on new arrivals, trending items, or price changes across all categories.",
    icon: "ri-refresh-line",
  },
  {
    id: "benefit-2",
    title: "Beginner Friendly",
    description: "Designed with simplicity in mind, the kakobuy spreadsheet is easy to navigate for first-time users. Clear categories and intuitive layout make product discovery effortless.",
    icon: "ri-user-smile-line",
  },
  {
    id: "benefit-3",
    title: "Buying Guides",
    description: "Access comprehensive buying guides that help you make informed decisions. Our kakobuy spreadsheet includes detailed product comparisons and shopping tips.",
    icon: "ri-book-open-line",
  },
  {
    id: "benefit-4",
    title: "Shipping Tips",
    description: "Get practical shipping advice and estimated delivery information for every product category. The kakobuy spreadsheet helps you plan your purchases efficiently.",
    icon: "ri-truck-line",
  },
  {
    id: "benefit-5",
    title: "Safe Shopping",
    description: "Shop with confidence knowing that all products in our kakobuy spreadsheet come from verified and reputable sources. Your safety and satisfaction are our top priorities.",
    icon: "ri-shield-check-line",
  },
  {
    id: "benefit-6",
    title: "Organized Categories",
    description: "Browse through 14 carefully organized product categories. The kakobuy spreadsheet makes it simple to find exactly what you are looking for in seconds.",
    icon: "ri-layout-grid-line",
  },
];